// useScrollEdgeHook.js

import { useState, useCallback, useEffect, useRef } from 'react';

/**
 * Custom hook to detect if a scrollable element has reached its start or right edge.
 * @param ref - React ref object pointing to the scrollable element.
 * @returns An array containing two booleans (reachedStart, reachedRight) and an object with the onScroll event handler.
 */
const useScrollEdgeHook = (ref) => {
  const [scrollPosition, setScrollPosition] = useState({ scrollStart: 0, scrollWidth: 0, clientWidth: 0 });

  const onScroll = useCallback((event) => {
    const { scrollLeft, scrollWidth, clientWidth } = event.target;
    setScrollPosition({ scrollStart: scrollLeft, scrollWidth, clientWidth });
  }, []);

  useEffect(() => {
    if (ref.current) {
      const { scrollLeft, scrollWidth, clientWidth } = ref.current;
      setScrollPosition({ scrollStart: scrollLeft, scrollWidth, clientWidth });
    }
  }, [ref]);

  const reachedStart = scrollPosition.scrollStart === 0;
  const reachedRight = scrollPosition.scrollStart + scrollPosition.clientWidth >= scrollPosition.scrollWidth;

  let className = ''
  if (reachedStart) {
    className = 'hint-left-hide';
  }
  if (reachedRight) {
    className = 'hint-right-hide';
  }
  if (reachedRight && reachedStart) {
    className = 'hint-right-hide hint-left-hide'
  }
  if (!reachedRight && !reachedStart) {
    className = ''
  }

  return [reachedStart, reachedRight, { onScroll }, className];
};


const calcBorderStyle = (radius, reachedStart, reachedEnd) => {
  let style = {
    zIndex: 100,
    height: '100%',
    width: '100%',
    bottom: 0,
    position: 'absolute',
    pointerEvents: 'none',
    touchAction: 'auto',
    borderRadius: radius,

  };
  if (!reachedStart && !reachedEnd) {
    return {
      ...style,
      boxShadow: `inset -20px 0px 20px -20px rgba(0,0,0,0.5), inset 20px 0 20px -20px rgba(0,0,0,0.5)`,
    };
  }
  if (!reachedStart) {
    return {
      ...style,
      boxShadow: `inset 20px 0px 20px -20px rgba(0,0,0,0.5)`,
    };
  }
  if (!reachedEnd) {
    return {
      ...style,
      boxShadow: `inset -20px 0px 20px -20px rgba(0,0,0,0.5)`,
    };
  }
  return {
    ...style,
  };
};

export {useScrollEdgeHook, calcBorderStyle};